var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLFileModalImage flex items-center justify-center",class:{
    LLFileModalImage_fill: _vm.fill,
    LLFileModalImage_loaded: _vm.highResVisible,
    LLFileModalImage_failed: _vm.failed
  }},[(!_vm.highResVisible && !_vm.failed)?_c('div',{staticClass:"LLFileModalImage__loader"},[_c('LoadingIcon',{staticClass:"LLFileModalImage__loader-icon",attrs:{"size":48,"border-width":4}})],1):_vm._e(),(_vm.displaySrc)?_c('img',{staticClass:"LLFileModalImage__image",class:{ LLFileModalImage__image_loaded: _vm.highResVisible },attrs:{"src":_vm.displaySrc,"alt":"","draggable":"false"},on:{"load":_vm.onElementLoad,"error":_vm.onElementError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }